import React, { Component } from 'react';
import {NEW_BUSINESS_CONTRACTS, NEW_BUSINESS_TARGET_CONTRACTS} from '../utils/constants';
import * as Request from '../service/data-info-chart/requestsUtil';
import edit from '../resources/images/estrategas/tools/edit.svg';
import { Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';



class ContractsIndicators extends Component{

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.save = this.save.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state={ modal: false,
      contracts: undefined,
      target: undefined,
      newContracts: null,
      newTarget: null,
    };
  }

  componentDidMount(){
    this._Fetch();
  }

  _Fetch(){
    Request.getFetch(NEW_BUSINESS_CONTRACTS + this.props.year + '/' + this.props.month).then(resp=>{
      this.setState({ contracts: resp.contracts })
    });
    Request.getFetch(NEW_BUSINESS_TARGET_CONTRACTS + this.props.year).then(resp=>{
      this.setState({ target: resp.target })
    });
  }

  toggle(){
    this.setState({ modal: !this.state.modal})
  }

  save(){
    if(this.state.newContracts !== null){
      let params = {
        contracts: this.state.newContracts,
        month: this.props.month,
        year: this.props.year,
      };
      Request.postFetch3(NEW_BUSINESS_CONTRACTS, params).then(resp=>{
        this._Fetch();
      });
    }
    if(this.state.newTarget !== null){
      let params = {
        target: this.state.newTarget,
        year: this.props.year,
      };
      Request.postFetch3(NEW_BUSINESS_TARGET_CONTRACTS, params).then(resp=>{
        this._Fetch();
      });
    }
    this.toggle()
  }

  handleChange(evt){
    let target=evt.target;
    let name=target.name;
    let value=target.value;
    this.setState({ [name]: value});
  }

  render() {
    let classUser = this.props.authorization ? 'quality-edit' : 'quality-edit-unauthorized';
    return (
      <div className='container-fluid back-color-grey'>
        <div className={classUser}>
          <img src={edit} title="Editar" alt=" " onClick={this.toggle}/>
        </div>
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader className='header-modal'
                       toggle={this.toggle}>Periodo {this.props.dateModal}</ModalHeader>
          <ModalBody>
            <div className='container'>
              <div className='d-flex justify-content-center'>
                <p className='container-fluid'>Meta: </p>
                <Input placeholder="Meta anual" type="text" name="newTarget"
                       value={this.state.newTarget} onChange={this.handleChange}/>
              </div>
              <div className='d-flex justify-content-center'>
                <p className='container-fluid'>Contratos: </p>
                <Input placeholder="Contratos obtenidos" type="text" name="newContracts"
                       value={this.state.newContracts} onChange={this.handleChange}/>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.save}>Aceptar</Button>{' '}
            <Button color="danger" onClick={this.toggle}>Cancelar</Button>
          </ModalFooter>
        </Modal>

        <div className='row pt-4'>
          <div className='col-12 col-md-5 offset-0 offset-md-1'>
            <div className='iconbox-single d-flex justify-content-around'>
              <h5>Contratos meta a Mayo 2019:{/*{this.props.dateModal}:*/}</h5>
              <h5><b>{this.state.target}</b></h5>
            </div>
          </div>
          <div className='col-12 col-md-5'>
            <div className='iconbox-single d-flex justify-content-around'>
              <h5>Contratos obtenidos:</h5>
              <h5><b>{this.state.contracts}</b></h5>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContractsIndicators;



// WEBPACK FOOTER //
// ./src/components/contractsIndicator.js